export const apiKey = "AIzaSyDrYIHvfLTlOR3QoOom5JjWMhUDAc6U_hQ";



// WEBPACK FOOTER //
// ./.frontend.secrets.js